'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
  monthsShort: ['jan.', 'feb.', 'mar', 'apr.', 'may', 'jun', 'jul.', 'aug', 'sept.', 'oct.', 'nov.', 'dec.'],
  weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
  weekdaysShort: ['sun.', 'mon.', 'tue.', 'wed.', 'thu.', 'fri.', 'sat.'],
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY LT',
    LLLL: 'dddd D MMMM YYYY'
  },
  calendar: {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: 'dddd [last at] LT',
    sameElse: 'L'
  },
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: 'one minute',
    mm: '%d minutes',
    h: 'one hour',
    hh: '%d hours',
    d: 'one day',
    dd: '%d days',
    M: 'one month',
    MM: '%d months',
    y: 'one year',
    yy: '%d years'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/calendar.js
// module id = 993
// module chunks = 0